import { IServiceInfo } from "../../serviceProvider/types/interfaces";
import { useTranslation } from "react-i18next";

const TopData = ({ header, data, setSelectedProvider, selectedProvider }: any) => {
    const { t } = useTranslation()
    return (
        <div className={`top-data ${setSelectedProvider ? "provider" : ""}`}>
            <h4>{header}</h4>
            <div className="cards">
                {!data?.length && <h6>{t('no_data_found')}</h6>}
                {data?.map((item: IServiceInfo, index: number) => (
                    <div
                        onClick={(e) => {
                            e.stopPropagation();
                            if (setSelectedProvider) setSelectedProvider(item)
                        }}
                        className={`card ${selectedProvider?.id == item.id ? "active" : ""}`} key={index}>
                        <h6>{item.title || item.name}</h6>
                        <p>{item.number || item.count}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default TopData;